import type { TFunction } from 'i18next';

/**
 * IBAMA judging codes in words: the office kind (`SUPERINTENDENT`), the kind of
 * term record (`CURRENT_OCCUPANCY`) and a CONAMA disposition (`IMPROVIDO`).
 *
 * The judge pages and the CONAMA reunion page printed these ETL codes verbatim.
 * The data keeps the code; only the label is translated. A code the locale
 * does not name falls back to itself in lower case with its underscores opened
 * up, so a new ETL value is readable-if-plain rather than a raw key.
 */
function label(t: TFunction, group: string, code: string): string {
  return t(`ibama:judgeLabels.${group}.${code}`, { defaultValue: code.replace(/_/g, ' ').toLowerCase() });
}

export const officeKindLabel = (t: TFunction, code: string) => label(t, 'kinds', code);
export const actKindLabel = (t: TFunction, code: string) => label(t, 'acts', code);
export const dispositionLabel = (t: TFunction, code: string) => label(t, 'dispositions', code);
